export const locales = ['en', 'rs'] as const
export type Locale = (typeof locales)[number]
export const defaultLocale: Locale = 'en'
